import { Link } from 'react-router'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'

export const StepsSection: React.FC = () => {
  const steps = [
    {
      title: '下準備',
      body: '箱から枝を取り出したら、水に浸かる部分の葉を取り除きます。よく切れるハサミで茎の先を斜めに切ります。',
      images: [
        { src: image1, alt: '開封した様子' },
        { src: image2, alt: '茎をカットしている様子' },
      ],
    },
    {
      title: '水揚げ',
      body: '深めの容器にたっぷり水を入れ、枝をおよそ2〜3時間浸けておく「水揚げ」を。しっかり水を吸わせることで、枝の持ちが変わります。',
      src: image3,
      alt: '水に浸けている様子',
    },
    {
      title: '飾る',
      body: 'お気に入りの花器に入れて、お家の主役になる場所に飾ってあげてください！',
      src: image4,
      alt: '花器に入れる瞬間',
    },
  ]

  return (
    <section className="py-20 md:py-28 px-5">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-center text-2xl md:text-3xl font-medium text-black leading-relaxed">やることはこれだけ</h2>

        <div className="mt-12 relative">
          <div className="absolute left-9.75 top-20 bottom-20 w-px bg-gray/40" />

          <div className="space-y-14">
            {steps.map((s, i) => (
              <div key={i} className="flex gap-7">
                <div className="shrink-0 w-20 h-20 rounded-2xl border border-gray/60 bg-white flex flex-col items-center justify-center z-10 gap-1.5">
                  <span className="text-[10px] font-display tracking-[0.2em] text-dark-gray leading-none">STEP</span>
                  <span className="text-[26px] font-display font-semibold text-dark-gray leading-none">0{i + 1}</span>
                </div>

                <div className="flex-1 -mt-0.5 pb-2">
                  <h3 className="text-[18px] md:text-xl font-medium text-black leading-relaxed">{s.title}</h3>
                  {s.images ? (
                    <div className="mt-5 aspect-4/3 rounded-xl overflow-hidden bg-gray/30">
                      <div className="grid grid-cols-2 gap-0.5 w-full h-full">
                        {s.images.map((img, j) => (
                          <div key={j} className="overflow-hidden">
                            <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="mt-5 aspect-4/3 rounded-xl overflow-hidden bg-gray/30">
                      <img src={s.src} alt={s.alt} className="w-full h-full object-cover" />
                    </div>
                  )}
                  <p className="mt-5 text-[15px] text-main leading-[1.9]">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <Link
            reloadDocument
            to="/subscription/branch/howto"
            className="inline-flex items-center gap-2 px-6 py-3 border border-black rounded-full text-[13px] text-black hover:bg-black hover:text-white transition-colors"
          >
            もっと詳しい手順はこちら
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2.5 6h7M6.5 3l3 3-3 3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  )
}
